import { Grid, Box, } from '@mui/material';
import React from 'react';
import OurCover from '../../Component/OurCover/OurCover';
import OurTeam from '../../Component/Ourteam/OurTeam';
import WorksScss from './Works.module.scss';
import Office from '../../Common/Image/office1.jpg';
import Testimonials from '../../Component/Testimonials/Testimonials';

function Works() {

    return (
        <div>
            <OurCover ourHead="How it's works" />
            {/* worksPlan */}
            <section id={WorksScss.worksPlan}>
                <Grid container className={WorksScss.worksPlanCover}>
                    <Grid item xs={12} sm={7} md={7}>
                        <Box className={WorksScss.worksPlanCoverLeft}>
                            <Box className={WorksScss.worksPlanCoverLeftHead}>
                                <h5>Research and planning</h5>
                                <span>01</span>
                            </Box>
                            <Box className={WorksScss.worksPlanCoverLeftBody}>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={5} md={5}>
                        <Box className={WorksScss.worksPlanCoverRight}>
                            <img src={Office} alt='Office'></img>
                        </Box>
                    </Grid>
                </Grid>
                <Grid container className={WorksScss.worksPlanCover2}>
                    <Grid item xs={12} sm={5} md={5}>
                        <Box className={WorksScss.worksPlanCoverLeft}>
                            <img src={Office} alt='Office'></img>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={7} md={7}>
                        <Box className={WorksScss.worksPlanCoverRight}>
                            <Box className={WorksScss.worksPlanCoverRightHead}>
                                <h5>Prototyping and desing</h5>
                                <span>02</span>
                            </Box>
                            <Box className={WorksScss.worksPlanCoverRightBody}>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Grid container className={WorksScss.worksPlanCover}>
                    <Grid item xs={12} sm={7} md={7}>
                        <Box className={WorksScss.worksPlanCoverLeft}>
                            <Box className={WorksScss.worksPlanCoverLeftHead}>
                                <h5>Developing and testing</h5>
                                <span>03</span>
                            </Box>
                            <Box className={WorksScss.worksPlanCoverLeftBody}>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={5} md={5}>
                        <Box className={WorksScss.worksPlanCoverRight}>
                            <img src={Office} alt='Office'></img>
                        </Box>
                    </Grid>
                </Grid>
            </section>
            {/* testimonials */}
            <Testimonials />
            {/*  team*/}
            <Box className={WorksScss.team}>
                <OurTeam />
            </Box>
        </div>
    )
}

export default Works;